import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/lib/store/auth'
import { Navbar } from './navbar'
import { Button } from './button'

interface AuthGuardProps {
  readonly children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const openLoginDialog = useAuthStore((s) => s.openLoginDialog)
  const promptedRef = useRef(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (isAuthenticated) {
      promptedRef.current = false
      return
    }
    if (promptedRef.current) return
    promptedRef.current = true
    openLoginDialog()
  }, [isAuthenticated, openLoginDialog])

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-background">
        <Navbar />
        <main className="mx-auto max-w-md px-6 py-24 text-center">
          <h2 className="text-2xl font-semibold text-foreground">{t('auth.signInToContinue')}</h2>
          <p className="mt-3 text-muted-foreground">
            {t('auth.pagePrivate')}
          </p>
          <Button className="mt-6" size="lg" onClick={openLoginDialog}>
            {t('auth.signInWithGoogle')}
          </Button>
        </main>
      </div>
    )
  }

  return <>{children}</>
}
